import styled from 'styled-components';
import common from '../../styles/common';
import { HiSearch } from 'react-icons/hi';
import { outlineGray, primaryColorLight, primaryColorWeak, textGrey } from '../../config/colors';

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
`;

export const Input = styled.input`
  width: 100%;
  ${common.input}
  padding-right: 1.75rem;
`;

export const SearchIcon = styled(HiSearch)`
  width: auto;
  height: 1.25rem;
  position: absolute;
  top: 50%;
  right: 0.5rem;
  transform: translateY(-50%);
  color: ${primaryColorLight};
  opacity: 0.7;
`;

export const DropdownWrapper = styled.div`
  position: absolute;
  top: 110%;
  left: 0;
  width: 100%;
  max-height: 180px;
  overflow-y: auto;
  outline: 1px solid ${outlineGray};
  box-shadow: 0px 10px 33px 4px rgba(0, 0, 0, 0.2);
  border-radius: 0.125rem;
  z-index: 10;
  background-color: white;
  padding: 0.25rem 0;
`;

export const NoRecommendations = styled.p`
  padding: 0.5rem 0.5rem;
  font-weight: 600;
  font-size: 0.875rem;
  color: ${textGrey};
  opacity: 0.7;
  line-height: 1.6;
  text-align: center;
`;

export const ItemWrapper = styled.div`
  padding: 0.5rem;
  :hover {
    cursor: pointer;
    background-color: ${primaryColorWeak};
  }
`;

export const ValueContainer = styled.span`
  font-size: 0.8rem;
`;
